import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import Input from '../Form/Input';
import Button from '../Base/Button';
import Translation from '../Base/Translation';
import Select from '../Form/Select';
import Label from '../Form/Label';
import Api from '../../Api';
import Popup from '../Base/Popup';
import ReportQuery from './ReportQuery';
import DateParser from '../../DateParser';
import NumberFormatter from '../../NumberFormatter';
import MortgageForm from './MortgageForm';

export default class EarlyPaymentForm extends React.Component {

    static settings = null;

    constructor(props) {

        super(props);

        this.state = {
            rate: null,
            target: null,
            firstPayment: null,
            lastPayment: null,
            isLastVisible: false,
        };

        this.nodes = {
            popup: null,
        };

    }

    getMortgageForm() {

        return this.props.form;
    }

    static get propTypes() {

        return {
            query: PropTypes.object,
            report: PropTypes.instanceOf(ReportQuery),
            form: PropTypes.instanceOf(MortgageForm),
            currency: PropTypes.object,
        };
    }

    static getSettings(props) {

        if (!EarlyPaymentForm.settings) {
            
            EarlyPaymentForm.settings = Api.fetch(`${Api.origin}/api/calc/setting.json`, {
                calculatorId: props.query.calculatorId,
                countryId: props.query.countryId,
                calculatorType: props.query.calculatorType,
            });
        }

        return EarlyPaymentForm.settings;
    }

    //------------------------------------------------------------------------------------------------------------------
    // INIT
    //------------------------------------------------------------------------------------------------------------------

    componentDidMount() {

        EarlyPaymentForm
            .getSettings(this.props)
            .then((response) => {
                
                if (response.success) {

                    this.setState({

                        rate: {
                            tag: 'calc.earlyPayment.rate',
                            items: response.setting.earlyPayments.type,
                        },

                        target: {
                            tag: 'calc.earlyPayment.target',
                            items: response.setting.earlyPayments.reduction,
                        },

                    });
                }
            });
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    render() {

        const title = <Translation tag='calc.earlyPayment.title' />;

        return (
            <Popup ref={ (node) => { this.nodes.popup = node; } } title={ title }>

                {/* <form ref={ (node) => { this.nodes.form = node; } }> */}

                    <Input
                        name='payment'
                        label={ this.props.payment.label }
                        value={ this.props.payment.value.formatted() }
                        format='number'
                        suffix={ this.props.currency }
                        />

                    <div className={ style('flex-grid-2 gap-lg mt-8') }>

                        { this.renderSelect(this.state.rate, 'rate', (e) => this.changeRateEvent(e)) }
                        { this.renderSelect(this.state.target, 'target') }
                        { this.renderSelectDate('calc.earlyPayment.firstDate', 'firstDate') }
                        {
                            this.state.isLastVisible
                                ? this.renderSelectDate('calc.earlyPayment.lastDate', 'lastDate')
                                : null
                        }

                    </div>

                    {/* button - add early payment */}
                    <div className={ style('flex justify-end') }>
                        <Button className={ style('mt-4 w-full desktop:size-320') } onClick={ () => this.closeEvent() }>
                            <i className={ style('icon-plus-circle') }></i>
                            <Translation tag='calc.amortization.addEarlyPayment' />
                        </Button>
                    </div>

                {/* </form> */}

            </Popup>
        );

    }

    renderSelect(props, name, changeEvent = null) {

        if (props == undefined)
            return null;

        const options = Object
            .entries(props.items)
            .map(([value, label]) => <option key={ value } value={ value }>{ label }</option> );

        return (
            <div className={ style('flex flex-wrap gap-md w-full') }>
                <Label className={ style('w-full') }><Translation tag={ props.tag }/></Label>
                <Select
                    onChange={ changeEvent }
                    className={ style('w-full') }
                    value={ options[0].props.value }
                    name={ name }>
                        { options }
                </Select>
            </div>
        );
    }

    renderSelectDate(tag, name) {

        return (<>
            { this.renderSelect({ tag, items: this.getYears() }, `${name}Year`) }
            { this.renderSelect({ tag: null, items: this.getMonths() }, `${name}Month`) }
        </>);
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACTIONS
    //------------------------------------------------------------------------------------------------------------------

    show() {

        this.nodes.popup.show();
    }

    hide() {

        this.nodes.popup.hide();
    }

    getQuery() {

        const container = this.nodes.popup.getNativeElement();
        return {
            value: NumberFormatter.parse(container.querySelector('[name="payment"]').value, 0, '').toFloat(),
            type: container.querySelector('[name="rate"]').value,
            reduction: container.querySelector('[name="target"]').value,
            year: container.querySelector('[name="firstDateYear"]').value,
            month: container.querySelector('[name="firstDateMonth"]').value,
            year_end: container.querySelector('[name="lastDateYear"]')?.value,
            month_end: container.querySelector('[name="lastDateMonth"]')?.value,
        };
    }

    //------------------------------------------------------------------------------------------------------------------
    // EVENTS
    //------------------------------------------------------------------------------------------------------------------

    closeEvent() {

        this.props.report.addEarlyPayment(this.getQuery());

        this.nodes.popup
            .getNativeElement()
            .closest('form')
            .dispatchEvent(new Event('submit'));
            
        this.hide();
    }

    changeRateEvent(e) {

        this.setState({ isLastVisible: (e.detail.value != 'single') });
    }

    //------------------------------------------------------------------------------------------------------------------
    // GETTERS, SETTERS
    //------------------------------------------------------------------------------------------------------------------

    getYears() {

        const years = {};
        Object
            .keys(this.props.table.years)
            .map((year) => {

                years[year] = year;
            });

        return years;
    }

    getMonths() {

        return DateParser.getMonths();
    }

}